import { render, staticRenderFns } from "./item-url.vue?vue&type=template&id=75a250bf&scoped=true&"
import script from "./item-url.vue?vue&type=script&lang=js&"
export * from "./item-url.vue?vue&type=script&lang=js&"
import style0 from "./item-url.vue?vue&type=style&index=0&id=75a250bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a250bf",
  null
  
)

export default component.exports